import analytics from './analytics';
import colors from './colors';
import common from './common';
import dom from './dom';
import environments from './environments';
import formats from './formats';
import network from './network';
import translations from './translations';

export default {
    analytics,
    colors,
    common,
    dom,
    environments,
    formats,
    network,
    translations,
};
